import { PropsWithChildren } from "react";

const Card = ({
  children,
  className = "",
  id,
}: PropsWithChildren<{ className?: string; id?: string }>) => {
  return (
    <div
      id={id}
      className={`border border-[#2C2C30] bg-white bg-opacity-[0.04] px-8 flex items-center ${className}`}
    >
      {children}
    </div>
  );
};

export default Card;
